<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 问号提示组件
  -->
  <el-popover
    popper-class="question-prompt"
    placement="bottom-start"
    width="340"
    trigger="hover"
    :content="content"
  >
    <i
      slot="reference"
      class="el-icon-question"
      style="color: #007aff; font-size: 14px; margin-left: 4px"
    />
  </el-popover>
</template>

<script>
export default {
  name: "question-prompt",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="less">
.question-prompt {
  font-size: 12px;
  background: #007aff;
  color: #ffffff;
}
.question-prompt[x-placement^="bottom"] .popper__arrow:after {
  display: none;
}
</style>